import React from "react";
import filterMap from "./SetFilterTags";
import "../scss/_OurResearch.scss";

const ResearchTagList = ({ setFilter, currentFilter }) => {
    const allFilterNames = Object.keys(filterMap);

    const FilterButton = ({ name, setFilter, isPressed }) => {
        return (
            <button
                type="button"
                className={`filterButton ${isPressed ? "active" : ""}`}
                onClick={() => setFilter(name)}
            >
                <span>{name}</span>
            </button>
        );
    };

    return (
        <div className="filterTags">
            {allFilterNames.map((name) => (
                <FilterButton
                    key={name}
                    name={name}
                    setFilter={setFilter}
                    isPressed={name === currentFilter}
                />
            ))}
        </div>
    );
};

export default ResearchTagList;
